var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"turn"}},[_c('img',{attrs:{"src":require("@/assets/images/template/loading.gif")}}),_c('span',[_vm._v(_vm._s(_vm.$t("trade.turn")))])])}
var staticRenderFns = []

export { render, staticRenderFns }